var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp = function SvgMp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M11.622 19.556a.782.782 0 0 1-.696-.511.783.783 0 0 1-1.397-.36.784.784 0 0 1-1.294-.635.782.782 0 0 1-1.14-.882.781.781 0 0 1-.94-1.092.783.783 0 0 1-.701-1.26.782.782 0 0 1-.433-1.375.782.782 0 0 1-.147-1.433.783.783 0 0 1 .143-1.434.783.783 0 0 1 .43-1.376.784.784 0 0 1 .7-1.26.782.782 0 0 1 .937-1.095.782.782 0 0 1 1.137-.885.783.783 0 0 1 1.294-.637.783.783 0 0 1 1.394-.363.783.783 0 0 1 1.44-.075.783.783 0 0 1 1.425.215.783.783 0 0 1 1.353.499.783.783 0 0 1 1.224.76.783.783 0 0 1 1.046.991.783.783 0 0 1 .827 1.18.784.784 0 0 1 .571 1.325.782.782 0 0 1 .293 1.41c.28.12.476.396.477.72V12a.784.784 0 0 1-.476.72.782.782 0 0 1-.29 1.412.783.783 0 0 1-.568 1.325.783.783 0 0 1-.824 1.183.784.784 0 0 1-1.044.993.784.784 0 0 1-1.222.764.784.784 0 0 1-1.352.502.783.783 0 0 1-1.425.217.782.782 0 0 1-.742.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 17.218a5.217 5.217 0 1 0 0-10.434 5.217 5.217 0 0 0 0 10.434Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBCC1",
    d: "M13.142 10.229a1.04 1.04 0 0 0 .423-.838V8.87c0-.576-.467-1.043-1.043-1.043h-1.044c-.576 0-1.043.467-1.043 1.043v.522c0 .344.167.648.423.838l-.945 9.597s.522.522 2.087.522c1.565 0 2.087-.522 2.087-.522l-.945-9.597Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m12 7.826.907 2.79h2.933l-2.373 1.724.906 2.79L12 13.406 9.627 15.13l.906-2.79-2.373-1.724h2.934L12 7.826Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMp;